import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: "none" | "md" | "lg";
  id?: string;
  onClick?: () => void;
}

export function Card({ children, className = "", padding = "lg", id, onClick }: CardProps) {
  const paddingClass =
    padding === "none" ? "" : padding === "md" ? "p-[18px]" : "p-[22px]";

  return (
    <article
      id={id}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={[
        "min-w-0 overflow-hidden rounded-[15px] border border-edlab-line bg-white shadow-[0_3px_10px_#303c4e03]",
        paddingClass,
        className,
      ].join(" ")}
    >
      {children}
    </article>
  );
}

interface CardHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function CardHeader({ title, description, action, className = "" }: CardHeaderProps) {
  return (
    <div
      className={[
        "mb-5 flex flex-wrap items-center justify-between gap-3",
        className,
      ].join(" ")}
    >
      <div>
        <h2 className="text-lg font-semibold tracking-[-0.3px] text-edlab-ink">{title}</h2>
        {description ? (
          <p className="mt-[5px] text-xs text-edlab-muted">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
